import "./CustomerReviews.module.css";
import Header from "@/reusable_sections/Header";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import ReviewSubmission from "./sections/ReviewSubmission";
import Footer from "@/reusable_sections/Footer";
export default function CustomerReviewsPage() {
  return <div>
      <Header />
      <CustomerTestimonials />
      <ReviewSubmission />
      <Footer />
    </div>;
}